import { z } from 'zod';

import { logger } from '@shared/lib/logger';
import { defineStorageItem, STORAGE_KEY } from '@shared/lib/storage';

/**
 * 배포 뒤 옛 index.html 이 사라진 청크를 가리킬 때의 복구.
 * `vite:preloadError` 에서 **한 번만** 새로고침한다. 표시는 부팅이 끝나면 반드시 지운다
 * (지우지 않으면 다음 배포 때 복구가 동작하지 않는다).
 */
const guard = defineStorageItem({
  key: STORAGE_KEY.CHUNK_RELOAD_GUARD,
  schema: z.object({ reloadedAt: z.number() }),
  fallback: null as { reloadedAt: number } | null,
  area: 'session',
});

export function installChunkReloadRecovery(reload: () => void = () => window.location.reload()) {
  const onPreloadError = (event: Event) => {
    if (guard.get() !== null) {
      // 이미 한 번 새로고침했다. 루프를 만들지 않고 에러를 그대로 흘려 ErrorBoundary 가 받게 한다.
      logger.error('청크를 불러오지 못했습니다(새로고침 뒤에도 실패)');
      return;
    }
    event.preventDefault();
    guard.set({ reloadedAt: Date.now() });
    reload();
  };

  window.addEventListener('vite:preloadError', onPreloadError);
  return () => window.removeEventListener('vite:preloadError', onPreloadError);
}

/** 부팅이 끝난 뒤(첫 화면이 그려진 뒤) 부른다. */
export function clearChunkReloadGuard() {
  guard.remove();
}
